export enum EModalExploreType {
  RECOGNITION = "RECOGNITION",
  COINS = "COINS",
}
